import { createStyles, rem } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var radius = _ref.radius,
      shadow = _ref.shadow;
  return {
    root: {
      outline: 0,
      WebkitTapHighlightColor: "transparent",
      display: "block",
      textDecoration: "none",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      boxSizing: "border-box",
      borderRadius: theme.fn.radius(radius),
      boxShadow: theme.shadows[shadow] || shadow || "none",
      "&[data-with-border]": {
        border: "".concat(rem(1), " solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3])
      }
    }
  };
});
export default useStyles;